    import axios from 'axios'
    import Result from '../../utils/serviceResultPattern'

    export default {
        listPaymentLinks(payload) {
        return axios
            .get('/api/reservation/payments', { params: payload })
            .then((res) => {
            if (!res || res.status !== 200 || !res.data) {
                return Result.error('We couldn\'t load the payment links at this time. Please try again or contact support if the issue persists.')
            }

            return Result.ok(res.data)
            })
            .catch((error) => {
            return Result.error(error)
            })
        },
        getPaymentLink(id) {
        return axios
            .get(`/api/reservation/payments/${id}`)
            .then((res) => {
            if (!res || res.status !== 200 || !res.data) {
                return Result.error('We couldn\'t load the payment link details at this time. Please try again or contact support if the issue persists.')
            }

            return Result.ok(res.data)
            })
            .catch((error) => {
            return Result.error(error)
            })
        },
        updatePaymentLink(id, payload) {
        return axios
            .patch(`/api/reservation/payments/${id}/update`, payload)
            .then((res) => {
            if (res.status < 200 || res.status >= 300) {
                return Result.error('We couldn\'t update the payment link at this time. Please try again or contact support if the issue persists.')
            }

            return Result.ok(res.data)
            })
            .catch((error) => {
            return Result.error(error)
            })
        },
        cancelPaymentLink(id) {
        return axios
            .patch(`/api/reservation/payments/${id}/cancel`)
            .then((res) => {
            if (res.status < 200 || res.status >= 300) {
                return Result.error('We couldn\'t cancel the payment link at this time. Please try again or contact support if the issue persists.')
            }

            return Result.ok(res.data)
            })
            .catch((error) => {
            return Result.error(error)
            })
        },
        exportPaymentLinks(payload) {
        return axios
            .get('/api/reservation/payments/export', { params: payload, responseType: 'blob' })
            .then((res) => {
            if (!res || res.status !== 200) {
                return Result.error('We couldn\'t export the payment links at this time. Please try again or contact support if the issue persists.')
            }

            const rawFilename = (res.headers['content-disposition'] || '').split('filename=')[1] || '';
            const filename = rawFilename.split(';')[0].trim().replace(/"/g, '') || 'payment-links.xlsx';

            return Result.ok({ blob: new Blob([res.data], { type: res.headers['content-type'] }), filename })
            })
            .catch((error) => {
            return Result.error(error)
            })
        }
    }



// WEBPACK FOOTER //
// ./src/api/reservation/paymentLinksService.js